/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import * as color from '@constant/color';
import React from 'react';
import TextBlock from '@component/common/block/text-block';

interface IProps {
  children?: React.ReactNode;
  text?: string;
  width?: string;
  icon?: React.ReactNode;
  blur: boolean;
}

const Wrapper = styled.div<{ $width: string }>`
  position: relative;
  width: ${(props) => props.$width};
`;

const BlurContainer = styled.div`
  filter: blur(2px);
  -webkit-filter: blur(2px);
`;

const TextContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  pointer-events: none;
`;

const Blur: React.FC<IProps> = ({ children, text, width = 'fit-content', icon, blur }) => {
  if (!blur) {
    return <>{children}</>;
  }

  return (
    <Wrapper $width={width}>
      <BlurContainer>{children}</BlurContainer>
      <TextContainer>
        {icon ? (
          icon
        ) : text ? (
          <TextBlock
            text={text}
            design={{
              text: { size: 'medium', color: color.BLACK_2, bold: false },
              box: { alignX: 'center' },
            }}
          />
        ) : null}
      </TextContainer>
    </Wrapper>
  );
};

export default Blur;
